export default __webpack_public_path__ + "static/media/aeriesl-1-point-5-768x511.c2688b05.jpg";